export class Timer {
  constructor(delay) {
    this.queue = [];
    this.stop = false;
    this.createTimer(delay);
  }

  createTimer(delay) {
    const self = this;
    let first = true;

    function runCallBack() {
      // 记录开始时间
      const start = new Date();
      self.queue.forEach((cb) => {
        // 执行队列中所有回调函数
        cb();
      });
      if (!self.stop) {
        // 未结束则继续递归
        const cost = new Date() - start;
        // 矫正阻塞时差
        const duration = first
          ? delay
          : ((cost > delay) ? (cost - delay) : delay);
        setTimeout(runCallBack, duration);
      }
    }

    runCallBack();
    first = false;
  }

  add(cb) {
    this.queue.push(cb);
    this.stop = false;
    // 返回当前index，用于remove时定位
    return this.queue.length - 1;
  }

  remove(index) {
    this.queue.splice(index, 1);
    if (this.queue.length === 0) {
      this.stop = true;
    }
  }
}

export class TimePool {
  constructor() {
    this.pool = {};
  }

  getTimer(delay) {
    const t = this.pool[delay];
    if (t) {
      return t;
    }
    this.pool[delay] = new Timer(delay);
    return this.pool[delay];
  }

  removeTimer(delay) {
    if (this.pool[delay]) {
      delete this.pool[delay];
    }
  }
}
